import { canShowAppPages } from '@members/feature-toggles/featureToggles';

export const useGetApps = () => canShowAppPages();
